import React, { FunctionComponent } from 'react'
import { Paragraph } from '@scentregroup/ui'
import { QRCode } from 'react-qr-svg'

import { CallToAction as CallToActionModel } from '../store'

import styles from './index.scss'

interface CallToActionProps {
  action?: CallToActionModel
}

const CallToAction: FunctionComponent<CallToActionProps> = ({ action }) => {
  if (!action) {
    return null
  }

  const category = action.category.toLowerCase()
  if (category === 'book now') {
    return (
      <div className={styles.popup}>
        <div className={styles.code}>
          <div className={styles.actualCode}>
            <QRCode value={action.address} />
          </div>
          <Paragraph className={styles.scan}>
            Scan this code with your phone&apos;s camera to visit website
          </Paragraph>
        </div>
      </div>
    )
  } else if (category === 'view menu') {
    return (
      <iframe
        className={styles.frame}
        src={action.address}
        title="Call to action"
      />
    )
  } else {
    return <p>Action not found</p>
  }
}

export default CallToAction
